import type { Money } from "@astro/types";

/** Format minor-unit money for display. */
export function formatMoney({ amount, currency }: Money, locale = "en-IN"): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount / 100);
}

/** Format an ISO date for display. */
export function formatDate(iso: string, locale = "en-IN"): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(new Date(iso));
}

/** Merge Tailwind class strings, dropping falsy values. Real apps may swap in `tailwind-merge`. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

/** Type-safe sleep. */
export const sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

/** Narrow unknown errors to a message string. */
export function toMessage(err: unknown, fallback = "Something went wrong"): string {
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;
  return fallback;
}
